import { actionTypes } from "./actions";
import { createGregorianCalendar } from "./gregorianCalendar";

const reducer = (state = createGregorianCalendar(), action) => {
  switch (action.type) {
    case actionTypes.CHANGE_DATE_FORMAT:
      return state.set("dateFormat", action.format);
    case actionTypes.CHANGE_TIME_FORMAT:
      return state.set("timeFormat", action.format);
    case actionTypes.CHANGE_DATE_FORMAT_INCLUDES_DAY_NAME:
      return state.set("dateFormatIncludesDayName", action.includesDay);
    case actionTypes.CHANGE_DATE_ORDER:
      return state.set("dateOrder", action.order);
    default:
      return state;
  }
};

export default reducer;
